import { HttpHeaders } from '@angular/common/http';
import { inject } from '@angular/core';
import { ApolloClientOptions, InMemoryCache, NormalizedCacheObject } from '@apollo/client/core';
import { provideNamedApollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';

import { environment } from '@env/environment';
import { ServerName } from '@graphql/shared/enums/server-name.enum';

const initClientOptions = (
  httpLink: HttpLink,
  uri: string,
): ApolloClientOptions<NormalizedCacheObject> => {
  const cache = new InMemoryCache();
  const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  const link = httpLink.create({ uri, headers });
  return { cache, link };
};

export const APOLLO_NAMED_PROVIDER = provideNamedApollo(() => {
  const httpLink = inject(HttpLink);
  return {
    EmployeeGraphQL: initClientOptions(httpLink, environment.graphql.employee.url),
    GatewayGraphQL: initClientOptions(httpLink, environment.graphql.gateway.url),
    ProjectGraphQL: initClientOptions(httpLink, environment.graphql.project.url),
    RBSGraphQL: initClientOptions(httpLink, environment.graphql.rbs.url),
    WageGraphQL: initClientOptions(httpLink, environment.graphql.wageData.url),
  } as Record<ServerName, ApolloClientOptions<NormalizedCacheObject>>;
});
